module.exports = __webpack_public_path__ + "img/classes_timeline.4cac0361.png";